export const CashCallActionTableColumns = [
{
    key: "details",
    label: "",
    sortable: false,
    thStyle: { width: "10px", textAlign: "center" }
},
{
  key: "status_actions",
  label: "Payment",
  sortable: false,
  thStyle: { width: "85px", textAlign: "center" }
},
{
  key: 'submitted_on',
  label: 'SUBMITTED ON',
  sortable: true,
  datePicker: {
    range: false
  },
  width: 150
},
{
  key: 'Created_By',
  label: 'Created By',
  sortable: true,
  searchable: true,
  width: 200,
},
{
  key: 'cash_call_reference',
  label: 'Reference',
  sortable: true,
  searchable: true,
  width: 200,
},
{
  key: 'Bdx_Key',
  label: 'LimeIQ Key',
  sortable: true,
  searchable: true,
  width: 400,
},
{
  key: 'Claim_Reference',
  label: 'Claim Ref',
  sortable: true,
  searchable: true,
  width: 120,
},
{
  key: 'Cash_Call_Request_Amount',
  label: 'Amount',
  width: 140,
  sortable: true,
  searchable: true
},
{
  key: 'TPA',
  label: 'TPA',
  sortable: true,
  searchable: true,
  width: 100,
},
{
  key: 'Broker',
  label: 'Broker',
  sortable: true,
  searchable: true,
  width: 100,
}, 
{
  key: 'Lead_Underwriter',
  label: 'Lead Underwriter',
  sortable: true,
  searchable: true,
  width: 200,
}, 
]